export const formateDateTimeLocale = (date: any) => {
    let DD = (date.getDate() < 10 ? '0' : '') + date.getDate();
    let MM = ((date.getMonth() + 1) < 10 ? '0' : '') + (date.getMonth() + 1);
    let YYYY = date.getFullYear();
    let HOURS = (date.getHours() < 10 ? '0' : '') + date.getHours();
    let MINUTES = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
    let SECONDS = (date.getSeconds() < 10 ? '0' : '') + date.getSeconds();
    return DD + '.' + MM + '.' + YYYY + ', ' + HOURS + ':' + MINUTES + ':' + SECONDS;
};